const messages = {
  it: {
    richiediInfo: 'Richiedi informazioni',
    scorri: 'Scroll',
    tornaSopra: 'Torna<br> sopra',

    contactsForm: {
      labelName: 'Nome',
      labelSurname: 'Cognome',
      labelEmail: 'Email',
      labelCompany: 'Azienda',
      labelTelephone: 'Telefono',
      labelCity: 'Città',
      labelMessage: 'Messaggio',
      labelEndCheck: 'Ai sensi e per gli effetti degli artt. 7, 12, 13 ss. del Reg. UE 2016/679 - GDPR:',
      labelAllowed: 'dichiaro di aver preso visione della',
      labelAllowed2: 'per il trattamento dei miei dati personali;',
      labelNewsletter: 'acconsento al trattamento dei miei dati personali per ricevere comunicazioni promozionali / commerciali.',
      labelSubmit: 'Invia la richiesta',
      brochureSubmit: 'SCARICA LA BROCHURE'
    },
    testoFooter: 'Ronda Engineering Srl<br> Sede legale in via Vegri, 83<br> 36010 – Zané (VI)',
    testoFooter2nd: 'T. <a href="tel:+390445385600">+39 0445 385600</a><br> M. <a href="mailto:roe.sales@ronda.it">roe.sales@ronda.it</a>',
    testoFooterCondizioniVendita: 'Condizioni di Vendita',
    testoFooterPrivacyCookie: 'Privacy e Cookie Policy',
    testoFooterDettagli: 'Vuoi conoscere i dettagli di EcoGasGenerator&reg;?',
    testoFooterDettagliTesto: 'Compila il modulo e ti ricontatteremo per fornirti tutte le informazioni.',
    testoFooterDettagliCta: 'Invia richiesta',

    vociMenu: {
      'impianto': 'Impianto',
      'comeFunziona': 'Come funziona',
      'vantaggi': 'Vantaggi',
      'servizi': 'Servizi',
      'azienda': 'Azienda',
      'contatti': 'Contatti'
    },

    pageNotFound: {
      'title': 'Pagina non trovata',
      'content': 'La pagina che stai cercando non è presente in questo sito.'
    },

    iconsLabels: {
      'energia_elettrica': 'energia elettrica',
      'energia_termica': 'energia termica',
      'biochar': 'biochar',
      'materiale_inerte': 'materiale inerte'
    },

    comeFunzionaSubs: {
      'fase': 'fase'
    },

    moreInfo: 'VUOI MAGGIORI<br>INFORMAZIONI?',
    richiedi: 'richiedi',
    brochureTecnica: 'BROCHURE<br>TECNICA',
    contattaci: 'contattaci',
    biocharCTA: 'SCOPRI IL NOSTRO BIOCHAR',
    impiantoCTA: 'Scopri l\'impianto',
    comeFunzionaCTA: 'Come funziona',
    closeLabel: 'Chiudi'
  },
  en: {
    richiediInfo: 'Request information',
    scorri: 'Scroll',
    tornaSopra: 'Scroll<br> top',

    contactsForm: {
      labelName: 'Name',
      labelSurname: 'Surname',
      labelEmail: 'Email',
      labelCompany: 'Company',
      labelTelephone: 'Telephone',
      labelCity: 'City',
      labelMessage: 'Message',
      labelEndCheck: 'Pursuant to and for the purposes of Articles 7, 13 and 15 of Regulation EU 2016/679 - GDPR:',
      labelAllowed: 'I declare that I have read the',
      labelAllowed2: 'to the processing of my personal data;',
      labelNewsletter: 'I agree to the processing of my personal data to receive promotional / commercial communications.',
      labelSubmit: 'Send request',
      brochureSubmit: 'DOWNLOAD THE BROCHURE'
    },

    testoFooter: 'Ronda Engineering Srl<br> Sede legale in via Vegri, 83<br> 36010 – Zané (VI)',
    testoFooter2nd: 'T. <a href="tel:+390445385600">+39 0445 385600</a><br> M. <a href="mailto:roe.sales@ronda.it">roe.sales@ronda.it</a>',
    testoFooterCondizioniVendita: 'General conditions',
    testoFooterPrivacyCookie: 'Privacy and Cookie Policy',
    testoFooterDettagli: 'You want to know the details of EcoGasGenerator&reg;?',
    testoFooterDettagliTesto: 'Fill out the form and we will get back to you with all the information.',
    testoFooterDettagliCta: 'Send request',

    vociMenu: {
      'impianto': 'System',
      'comeFunziona': 'How it works',
      'vantaggi': 'advantages',
      'servizi': 'Services',
      'azienda': 'Company',
      'contatti': 'Contacts'
    },

    pageNotFound: {
      'title': 'Page not found',
      'content': 'The page you are looking for is not available on this site.'
    },

    iconsLabels: {
      'energia_elettrica': 'electric energy',
      'energia_termica': 'thermal energy',
      'biochar': 'biochar',
      'materiale_inerte': 'inert material'
    },

    comeFunzionaSubs: {
      'fase': 'phase'
    },

    moreInfo: 'Do you want<br>more information?',
    richiedi: 'request',
    brochureTecnica: 'TECHNICAL<br>BROCHURE',
    contattaci: 'contact us',
    biocharCTA: 'DISCOVER OUR BIOCHAR',
    impiantoCTA: 'The Plant',
    comeFunzionaCTA: 'How does that work',
    closeLabel: 'Close'
  }
}

export default messages
